export function useMessageEventEmitter() {
  function emit<T = any>(event: string, data?: T) {
    window.parent.postMessage({ event, data }, '*');
  }

  return { emit };
}
